import React from 'react';

import { useApiGet, useApiLoading } from 'react-reqq-lite';

import { formatGetQueryParams } from 'modules/common/utils';

import * as c from './constants';
import * as actions from './actions';

export const useGetMenuBuilderList = (params) => {
  const isApiLoading = useApiLoading(c.GET_MENU_BUILDER_LIST, 'get');
  const list = useApiGet(`${c.GET_MENU_BUILDER_LIST}.list`, []);
  const pagination = useApiGet(`${c.GET_MENU_BUILDER_LIST}.pagination`, {});

  React.useEffect(() => {
    let time;
    if (params) {
      time = setTimeout(() => {
        actions.getMenuBuilderList(formatGetQueryParams(params, true));
      }, 300);
    }
    return () => clearTimeout(time);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(params)]);

  return [isApiLoading, list, pagination];
};

export const useCreateMenuBuilder = () => {
  const isApiLoading = useApiLoading(c.CREATE_MENU_BUILDER, 'post');
  const create = React.useCallback((payload, cb) => {
    actions.createMenuBuilder(payload, cb);
  }, []);

  return [isApiLoading, create];
};

export const useUpdateMenuBuilder = () => {
  const isApiLoading = useApiLoading(c.UPDATE_SELECTED_MENU_BUILDER, 'post');
  const create = React.useCallback((menu_builder_uuid, payload, cb) => {
    actions.updateMenuBuilder(menu_builder_uuid, payload, cb);
  }, []);

  return [isApiLoading, create];
};

export const useRemoveMenuBuilder = () => {
  const isApiLoading = useApiLoading(c.REMOVE_SELECTED_MENU_BUILDER, 'remove');
  const create = React.useCallback((menu_builder_uuid, cb) => {
    actions.removeMenuBuilder(menu_builder_uuid, cb);
  }, []);

  return [isApiLoading, create];
};
